import FaqAnswers from './FaqAnswers';

export default FaqAnswers;
